// eslint-disable-next-line @logicsoftware/ep-custom/no-cross-feature-imports
import { CommonActionTypes } from "~/app/const/actionTypes";
import { SuccessRequestAction } from "~/Redux/Middleware/apiMiddleware";
import { SetAccountSettings, UpdateAccountCurrency } from "../actions";
import { AccountSettingsActionsType } from "../const/actionsType";

export interface AccountSettingsState {
    accountSettings?: AccountSettings;
}

export interface AccountSettings {
    AreNotificationRulesEnabled: boolean;
    IsCustomSMTPEnabled: boolean;
    IsSalesAssisted: boolean;
    GuestRoleId: number;
    DontUseInStats: boolean;
    DefaultCurrencyId: number;
}

export interface AccountSettingsResponseModel {
    AccountSettings: Partial<AccountSettings>;
}

export type AccountSettingsActions =
    | SuccessRequestAction<CommonActionTypes.LOAD_USER_SETTINGS_SUCCESS, AccountSettingsResponseModel>
    | SetAccountSettings
    | UpdateAccountCurrency;

export const accountSettingsReducer = (
    state: AccountSettings = null,
    actions: AccountSettingsActions
): AccountSettings => {
    switch (actions.type) {
        case CommonActionTypes.LOAD_USER_SETTINGS_SUCCESS:
            return {
                ...state,
                ...actions.payload.AccountSettings,
            };
        case AccountSettingsActionsType.SET_ACCOUNT_SETTINGS:
            return {
                ...state,
                ...actions.value.AccountSettings,
            };
        case AccountSettingsActionsType.UPDATE_ACCOUNT_CURRENCY_SETTINGS:
            return {
                ...state,
                DefaultCurrencyId: actions.value,
            };
        default:
            return state;
    }
};
